import { render, staticRenderFns } from "./shopCommunity.vue?vue&type=template&id=558ffb79&scoped=true"
import script from "./shopCommunity.vue?vue&type=script&lang=js"
export * from "./shopCommunity.vue?vue&type=script&lang=js"
import style0 from "./shopCommunity.vue?vue&type=style&index=0&id=558ffb79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ffb79",
  null
  
)

export default component.exports